<template>
  <el-main class="rh-medform">
    <form-fcontinueedit :ismeddetail="true" :routetolist="contRouteToList" />
  </el-main>
</template>
<script>
import FormFcontinueedit from "@/components/rh/formulaires/FormFcontinueedit";

export default {
  components: { "form-fcontinueedit": FormFcontinueedit },
  computed: {
    contRouteToList() {
      return {
        name: "med_fcontinues",
        params: {
          idmed: this.$route.params.idmed,
        },
      };
    },
  },
};
</script>
